import { create } from "zustand";

/**
 * Thin module-level store for the pro header Messages icon badge
 * (messaging-inbox IA WS5). Mirrors the consumer notifications-store idiom:
 *
 * unreadCount: null = not yet fetched (badge hidden)
 * unreadCount: 0    = fetched, nothing unread (badge hidden)
 * unreadCount: n    = n conversations with unread messages (badge shows n)
 *
 * The count is CONVERSATIONS with ≥1 unread message (the backend
 * /threads/unread-count contract), not total unread messages — the badge
 * answers "how many conversations need me", matching the inbox sidebar's
 * per-row dots. Seeded by useMessagesBadge on header mount; re-synced by the
 * Messages inbox whenever its list loads or a conversation is marked read.
 */
interface MessagesState {
  unreadCount: number | null;
  setUnreadCount: (count: number) => void;
}

export const useMessagesStore = create<MessagesState>((set) => ({
  unreadCount: null,
  setUnreadCount: (count) => set({ unreadCount: count }),
}));
